import { Row, Col, Button, Flex, Space, Input, Anchor, Radio, DatePicker, FloatButton, InputNumber, Modal, Divider, notification, ConfigProvider } from 'antd';
import React, { useState, useEffect, useTransition, useRef } from 'react';
import { PageSection, PageContent, Field, PageHeader, StickyButtons } from '../../styles/global/Pages.styled';
import { Widget } from "../Global/Atomics/Widget";
import { Text } from '../Global/Atomics/Text';
import CustomIcon from '../Global/Icons/CustomIcon';
import { useNavigate, useParams } from 'react-router';
import useFetch from '../../server/useFetch';
import query from '../../server/constants.api';
import { useTranslation } from 'react-i18next';
import { SelectAtomic } from '../Global/Atomics/SelectAtomic';
import i18next from 'i18next';
import Spinner from '../Global/Atomics/Spinner';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import domtoimage from "dom-to-image";
import * as XLSX from 'xlsx';
import { useAuthContext } from '../../contexts/AuthContext';
import enUS from 'antd/lib/locale/en_US';
import ptBR from 'antd/lib/locale/pt_BR';
import { CostTable } from '../Global/Molecules/Registry/CostTable';
import { RelatedAssetsTable } from '../Global/Molecules/Registry/RelatedAssetsTable';
import { EventsTable } from '../Global/Molecules/Registry/EventsTable';
import { GasConsumption } from '../Global/Molecules/Registry/GasConsumption';
import { ExportRawData } from '../Global/Molecules/Registry/ExportRawData';
import { LoadDiagram } from '../Global/Molecules/Registry/LoadDiagram';
import { AverageElectricConsumption } from '../Global/Molecules/Registry/AverageElectricConsumption';
import { ProductionEnergy } from '../Global/Molecules/Registry/ProductionEnergy';
import { ElectricEnergy } from '../Global/Molecules/Registry/ElectricEnergy';
// import { RegisterData } from './RegisterDetail/RegisterData';
import { CertificationTable } from '../Global/Molecules/Registry/CertificationTable';
import { RegistryDailyAnalysis } from '../Global/Organism/Registry/RegistryDailyAnalysis';
import "dayjs/locale/pt-br";
import logger from '../../server/logger';
import { RegisterData } from '../Global/Molecules/Registry/RegisterData';
import { RegistryHistorical } from '../Global/Organism/Registry/RegistryHistorical';
import styled from 'styled-components';
import Theme from '../../styles/Theme/Theme';

const SegmentedWarper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  margin-top: 1%;
`;

const SegmentedControlStyle = styled.div`
  display: flex;
  background-color: ${Theme.color["white"]};
  border-radius: 30px;
  /* box-shadow: ${Theme.shadow.level3}; */
  height: 45px; //50px
  gap: 10px; //20px
  padding: 0 10px;
`;

const ButtonLink = styled.div`
  background-color: ${(props) =>
    props.$backgroundColor ? Theme.color["black-1"] : Theme.color["white"]};
  color: ${(props) =>
    props.$backgroundColor ? Theme.color["white"] : Theme.color["black-1"]};
  height: 35px; //40px
  border-radius: 30px;
  align-self: center;
  display: flex;
  cursor: pointer;
  text-align: -webkit-center;

  > p {
    align-self: center;
    padding: 0 24px;
  }
`;

dayjs.extend(utc);
dayjs.extend(timezone);

export const RegisterDetail = () => {
  const { t } = useTranslation();
  // const { id } = useParams();
  // const navigate = useNavigate();
  // const [api, contextHolder] = notification.useNotification();
  // const { checkToken } = useAuthContext();

  const [dataRegisterDetail, setDataRegisterDetail] = useState(null);
  // const [activeDailyAnalisis, setActiveDailyAnalisis] = useState(true);
  // const [activeTimeline, setActiveTimeline] = useState(false);

  // function handleSetTabActive(tab) {
  //   switch (tab) {
  //     case 1:
  //       setActiveDailyAnalisis(true);
  //       setActiveTimeline(false);
  //       break;
  //     case 2:
  //       setActiveDailyAnalisis(false);
  //       setActiveTimeline(true);
  //       break;
  //   }
  // }

  // const [showEdit, setShowEdit] = useState(false);
  // const handleEdit = () => {
  //   setShowEdit(true);
  // }

  //#region SynergyComment: Filter 



  //#endregion

  //#region SynergyComment: Export Raw Data



  //#region -------------Anchors-------------------//
  // const [timelineAnchorsItems, setTimelineAnchorsItems] = useState([
  //   {
  //     href: '#Eletric Energy',
  //     title: t('eletricEnergy'),
  //     key: 'eletricEnergy'
  //   },
  //   {
  //     href: '#Cost Estimation',
  //     title: t('costEstimation'),
  //     key: 'costEstimation',
  //   },
  //   {
  //     href: '#Load Diagrams',
  //     title: t('loadDiagrams'),
  //     key: 'loadDiagrams',
  //   },
  //   {
  //     href: '#Export',
  //     title: t('export'),
  //     key: 'export',
  //   },
  //   {
  //     href: '#Energetic certification',
  //     title: t('energeticCertification'),
  //     key: 'energeticCertification',
  //   },
  // ]);

  // useEffect(() => {
  //   let anchors = [
  //     {
  //       href: '#Eletric Energy',
  //       title: t('eletricEnergy'),
  //       key: 'eletricEnergy'
  //     },
  //     {
  //       href: '#Cost Estimation',
  //       title: t('costEstimation'),
  //       key: 'costEstimation',
  //     },

  //     {
  //       href: '#Export',
  //       title: t('export'),
  //       key: 'export',
  //     },
  //     {
  //       href: '#Energetic certification',
  //       title: t('energeticCertification'),
  //       key: 'energeticCertification',
  //     },
  //   ]

  //   if (dataLoadDiagram?.potency?.series?.length) {
  //     anchors.push({
  //       href: '#Load Diagrams',
  //       title: t('loadDiagrams'),
  //       key: 'loadDiagrams',
  //     },)
  //   }
  //   if (dataGasConsumption?.gas?.series?.length) {
  //     anchors.push({
  //       href: '#Gas Consumption',
  //       title: t('gasConsumption'),
  //       key: 'gasConsumption',
  //     })
  //   }
  //   if (dataEvents?.length) {
  //     anchors.push({
  //       href: '#Events',
  //       title: t('events'),
  //       key: 'events',
  //     })
  //   }
  //   if (dataRelatedAssets) {
  //     anchors.push({
  //       href: '#Related Assets',
  //       title: t('relatedAssets'),
  //       key: 'relatedAssets',
  //     })
  //   }

  //   setTimelineAnchorsItems(anchors)
  // }, [dataGasConsumption, dataEvents, dataRelatedAssets, dataLoadDiagram]);

  //#endregion

  const buttons = ['Daily Analysis', 'Historical'];
  const [selectedTab, setSelectedTab] = useState('Daily Analysis');

  return (
    <>
      <PageContent $backgroundColor='neutral-1'>
        <Row>
          <Col span={24}>
            <PageSection>
              {/* {showEdit ?
                <EditData dataRegisterDetail={dataRegisterDetail} cancelEdit={(value) => setShowEdit(value)} />
                : */}
              <Flex gap={16} vertical="true">
                <Flex gap={16} justify='center' horizontal='true'>
                  {/* <Button className={activeDailyAnalisis ? 'ant-btn-black' : 'ant-btn-outline'} onClick={() => handleSetTabActive(1)}>{t('Daily Analysis')}</Button>
                  <Button className={activeTimeline ? 'ant-btn-black' : 'ant-btn-outline'} onClick={() => handleSetTabActive(2)}>{t('Historical')}</Button> */}
                  <SegmentedWarper>
                    <SegmentedControlStyle>
                      {buttons?.map((x, index) => {
                        return (
                          <ButtonLink
                            key={index}
                            onClick={() => setSelectedTab(x)}
                            $backgroundColor={selectedTab == x ? true : false}
                          >
                            <p>{t(x)}</p>
                          </ButtonLink>
                        );
                      })}
                    </SegmentedControlStyle>
                  </SegmentedWarper>
                </Flex>

                <Flex id="registerData" className='first-section' gap={32} vertical="true">
                  <Flex align="center" justify="space-between">
                    <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{dataRegisterDetail?.title}</Text>
                  </Flex>

                  <RegisterData hasRegisterDetail={(value) => setDataRegisterDetail(value)} />

                </Flex>

                {selectedTab === 'Daily Analysis' ? <RegistryDailyAnalysis /> : null}

                {selectedTab === 'Historical' ? <RegistryHistorical dataRegisterDetail={dataRegisterDetail}/> : null}
              </Flex>

              {/* } */}
            </PageSection>
          </Col>
        </Row>

      </PageContent >
      <FloatButton.BackTop icon={<CustomIcon icon='ArrowUp' color='blue-4' />} />
    </>
  );
}